import { ParsedUrlQuery } from 'querystring';
import { Content, User } from 'common/apiService';

export function getVideoFile(content: Content, type: 'primary' | 'trailers' = 'primary') {
  const [file] = content?.video_files?.[type] || [];
  return file?.video_file_id;
}

export function timespanToSeconds(hms = '') {
  return hms.split(':').reduce((seconds, t, idx) => seconds + +t * [3600, 60, 1][idx], 0);
}

export function getTimerDuration(end?: string, now?: string) {
  if (!end) return;

  // const y = end.replace('T', ' ');
  // const z = now ? now?.replace('T', ' ') : null;

  const nowDate = now ? new Date(now).toUTCString() : new Date().toUTCString();
  const endDate = new Date(end).toUTCString();

  const nowInSeconds = new Date(nowDate).getTime() / 1000;
  const endInSeconds = new Date(endDate).getTime() / 1000;

  const timer = endInSeconds - nowInSeconds;
  if (timer > 0) return endInSeconds - nowInSeconds;
}

export const rialsToTomans = (price: number) => (price / 10).toLocaleString();

export const trimPrice = (price: string) => price.replace('تومان', '').trim();

export function debounce(func, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export const persianNumber2englishNumber = (s) => s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

export const persianPhoneRegix = /^(0|98|0098|\+98)9\d{9}$/;
export const persianPhoneRegixPattern = new RegExp(persianPhoneRegix);
export const farsiNumberRegix = new RegExp(/[۰-۹]/g);

export function replacePhoneNumberPrefix(phoneNumber: number): string {
  const phoneNumberString: string = phoneNumber.toString();
  const regex = /^(?:\+98|98)/;
  if (regex.test(phoneNumberString)) {
    const modifiedPhoneNumberString: string = phoneNumberString.replace(regex, '');
    const modifiedPhoneNumberWithPrefix = `0${modifiedPhoneNumberString}`;
    return modifiedPhoneNumberWithPrefix;
  }
  return phoneNumberString;
}

export const timeToSeconds = (time: string | undefined) => {
  if (!time) return 0;
  const a = time.split(':');
  return (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
};

export const timeToMinuets = (time: string | undefined) => {
  if (!time) return 0;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return Math.floor(timeToSeconds(time)! / 60);
};

export const extractRedirectParam = (url: string): string | null  => {
  const redirectIndex = url.indexOf('redirect=');
  if (redirectIndex === -1) return null;

  const redirectValue = url.slice(redirectIndex + 9);
  return redirectValue || '/';
};

/** The `config` query param of a landing link; the backend tailors the packages and gateways it returns by it. */
export const getConfigParam = (query: ParsedUrlQuery): string | undefined => (
  typeof query.config === 'string' && query.config ? query.config : undefined
);

export const sanitizeHtml = (data) => {
  return data?.replace(/<[^>]*>/g, ' ')
    // remove ZWNJ (Unicode + entities)
    ?.replace(/\u200c|&zwnj;|&#8204;/gi, '')
    // remove NBSP
    ?.replace(/\u00a0|&nbsp;|&#160;/gi, ' ')
    // normalize spaces
    ?.replace(/\s+/g, ' ')
    ?.trim()
    // SEO-safe length
    ?.slice(0, 20);
};

// Label of every "buy / extend subscription" call to action.
// Same precedence as SubscriptionStatus: no purchased subscription — carrier / operator access
// included, since 'has_carrier_subscription' does not contain 'has_subscription' as a substring —
// means "buy", a purchased one with less than a day left means "about to end".
export function getSubscriptionButtonMessage(user: User | null | undefined, subscriptionRemainingDays: number) {
  const hasPaidSubscription = user?.conditional_flag?.includes('has_subscription') ?? false;

  return !hasPaidSubscription
    ? 'subscription.buy'
    : subscriptionRemainingDays <= 0
      ? 'subscription.less.one.day'
      : 'subscription.extend';
}
